import React from 'react'
import DateSection from '../../ReservationSegmentCard/tabs/DateSection'
import ReservationSegmentBuilderAccommodationSection from "../ReservationSegmentBuilderAccommodationSection"
import AccommodationSection from '../../ReservationSegmentCard/tabs/AccommodationSection'

export default class ReservationSegmentBuilderAccommodations extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="panel panel-default">
        <div className="panel-body edit-acc-panel">
          {this.renderErrors()}
          {
            this.props.reservation_segment.ru_res_apa_id || this.props.reservation_segment.ru_reservation_id
          ? 
            this.renderRentalsUnitedWarning()
          :
            null
          }
          <DateSection {...this.props} />
          <ReservationSegmentBuilderAccommodationSection {...this.props} rentals_united_reservation={this.props.reservation_segment.ru_res_apa_id || this.props.reservation_segment.ru_reservation_id ? true : false} />
        </div>
      </div>
    );
  };

  renderRentalsUnitedWarning = () => {
    if (this.props.reservation_segment.ru_channel && this.props.reservation_segment.ru_channel.channel_name){
      return (
        <h5 className="alert alert-info text-center" role="alert">{I18n.t('rentals_united_edit_warning', {channel_name: this.props.reservation_segment.ru_channel.channel_name})}</h5>
      );
    } else{
      return (
        <h5 className="alert alert-info text-center" role="alert">{I18n.t('generic_rentals_united_edit_warning')}</h5>
      );
    };
  };

  renderErrors() {
    var errors = this.props.errors;

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return(
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
}
